<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col">
        <div class="no-gutters row">


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="checklist-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-model')"
                      to="checklist-type-model">
              <i class="lnr-layers btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Modelos de Inspeção
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-not-inspected')"
                      to="checklist-type-not-inspected">
              <i class="lnr-cross-circle btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Motivos Não Inspeção
            </t-button>
          </div>


        </div>



        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-pathology')"
                      to="checklist-type-pathology">
              <i class="lnr-thumbs-down	btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Anomalias
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-evidence-category')"
                      to="checklist-type-evidence-category">
              <i class="lnr-inbox	btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Categorias Evolução
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-evidence-service')"
                      to="checklist-type-evidence-service">
              <i class="lnr-paperclip	btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Serviços Evolução
            </t-button>
          </div>

        </div>

        <div class="no-gutters row">


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-operation-status')"
                      to="checklist-type-operation-status">
              <i class="lnr-file-empty btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Status de Inspeções
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-evidence-status')"
                      to="checklist-type-evidence-status">
              <i class="lnr-file-empty btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Status de Evolução
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-occurrence-status')"
                      to="checklist-type-occurrence-status">
              <i class="lnr-file-empty btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Status de Apontamentos
            </t-button>
          </div>


        </div>

        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-criticality')"
                      to="checklist-type-criticality">
              <i class="lnr-heart-pulse btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Criticidades
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-regulation')"
                      to="checklist-regulation">
              <i class="lnr-book btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Normas Técnicas
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-estate-item-status')"
                      to="checklist-type-estate-item-status">
              <i class="lnr-star btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Condições de Itens
            </t-button>
          </div>

        </div>


      </div>

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'EmployeeSettings',
  data() {
    return {}
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    }
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
